
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"APPLE_VENMO_SUBMIT_ORDER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"basketId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"btRequest"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BrainTreePreprocessorDTO"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBenefitsDTO"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderBenefitsDTO"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"basketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"basketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"btRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"btRequest"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBenefitsDTO"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBenefitsDTO"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderNo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creationDate"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ORDER_ITEMS"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ORDER_SUMMARY"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"COUPON_ITEMS"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BILLING_DETAILS"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SHIPPING_DETAILS"},"directives":[]}]}}]}}],"loc":{"start":0,"end":564}};
    doc.loc.source = {"body":"#import './couponItems.fragment.graphql'\n#import './billing.fragment.graphql'\n#import './shipping.fragment.graphql'\n#import './orderItems.fragment.graphql'\n#import './summary.fragment.graphql'\n\nmutation APPLE_VENMO_SUBMIT_ORDER($basketId: String, $btRequest: BrainTreePreprocessorDTO, $orderBenefitsDTO: OrderBenefitsDTO) {\n  submitOrder(basketId: $basketId, btRequest: $btRequest, orderBenefitsDTO: $orderBenefitsDTO) {\n   orderNo\n     creationDate\n    ...ORDER_ITEMS\n    ...ORDER_SUMMARY\n    ...COUPON_ITEMS\n    ...BILLING_DETAILS\n    ...SHIPPING_DETAILS\n\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./couponItems.fragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./billing.fragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./shipping.fragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./orderItems.fragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./summary.fragment.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["APPLE_VENMO_SUBMIT_ORDER"] = oneQuery(doc, "APPLE_VENMO_SUBMIT_ORDER");
        
